/* eslint-disable @typescript-eslint/naming-convention */

/** One person-unavailability block from GET /api/manpowers/unavailability. */
export interface PersonUnavailabilityDto {
  PersonUnavailabilityID: string;
  EmployeeID: string | null;
  ProspectID: string | null;
  /**
   * The person's display name ("Last, First Middle"), joined server-side. The
   * People view's seeded rows need it because the candidate pool is take-capped
   * and cannot be relied on to contain every person with a block (#30952).
   */
  FullName?: string | null;
  StartDate: string | null;
  EndDate: string | null;
  /** Null when the caller lacks PM Dashboard edit: the API withholds the reason and note (Bug 37173). */
  Reason: string | null;
  Note: string | null;
}

/** POST /api/manpowers/unavailability body — exactly one of EmployeeID/ProspectID. */
export interface SavePersonUnavailabilityDto {
  EmployeeID?: string | null;
  ProspectID?: string | null;
  StartDate: string | null;
  EndDate: string | null;
  Reason: string;
  Note: string;
}

/** PUT /api/manpowers/unavailability/{id} body — only the provided fields change. */
export interface UpdatePersonUnavailabilityDto {
  StartDate?: string | null;
  EndDate?: string | null;
  Reason?: string | null;
  Note?: string | null;
  BActive?: boolean | null;
}
